<template>
    <section class="container">
        <router-view :key="key" />
    </section>
</template>

<script>
    export default {
        name: 'Wrapper',
        computed: {
            key() {
                return this.$route.path
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>